import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { CustomCellRendererProps } from 'ag-grid-react';
import { Tooltip } from '@wk/components-v3-react16';
import { ServerDashboardJob } from '../../dashboardType';
import styles from './FileNameCell.module.scss';

const FileNameCell = (
  properties: CustomCellRendererProps<ServerDashboardJob>
) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const cellReference = useRef<HTMLDivElement>(null);

  const displayValue = properties.data?.originalFileName || '';
  const cellId = `filename-${properties.data?.jobId}`;

  useLayoutEffect(() => {
    const checkTruncation = () => {
      if (cellReference.current) {
        const isCellTruncated =
          cellReference.current.scrollWidth > cellReference.current.clientWidth;
        setIsTruncated(isCellTruncated);
      }
    };

    checkTruncation();
    const timeoutId = setTimeout(checkTruncation, 100);

    return () => clearTimeout(timeoutId);
  }, [displayValue]);

  useEffect(() => {
    if (!cellReference.current) {
      return undefined;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (cellReference.current) {
        const isCellTruncated =
          cellReference.current.scrollWidth > cellReference.current.clientWidth;
        setIsTruncated(isCellTruncated);
      }
    });

    resizeObserver.observe(cellReference.current);

    return () => resizeObserver.disconnect();
  }, []);

  if (!displayValue) {
    return null;
  }

  return (
    <>
      <div className={styles.cellWrapper}>
        <div
          id={cellId}
          ref={cellReference}
          className={styles.cellText}
          onMouseEnter={() => setIsTooltipOpen(true)}
          onMouseLeave={() => setIsTooltipOpen(false)}
        >
          {displayValue}
        </div>
      </div>
      {isTruncated &&
        createPortal(
          <Tooltip
            targetSelector={`#${cellId}`}
            isOpen={isTooltipOpen}
            position="top"
          >
            {displayValue}
          </Tooltip>,
          document.querySelector('#root') as HTMLElement
        )}
    </>
  );
};

export default FileNameCell;
